var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sport_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.004-.001c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10m.635 3.249 2.571-1.383a8.8 8.8 0 0 1 3.611 2.663l-.612 2.827-1.961.962-3.61-2.63zm-3.82-1.39L9.39 3.245v2.443L5.784 8.317l-1.971-.963L3.2 4.509a8.8 8.8 0 0 1 3.62-2.651ZM2.79 14.94a8.7 8.7 0 0 1-1.493-4.092L3.414 8.55l1.93.944 1.454 4.129-1.23 1.472zm9.442 3.51a8.7 8.7 0 0 1-2.23.298 8.7 8.7 0 0 1-2.673-.421l-.786-2.448 1.254-1.506h4.417l1.231 1.457zm2.188-3.398-1.208-1.432 1.473-4.127 1.922-.941 2.103 2.297a8.7 8.7 0 0 1-1.18 3.589z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sport_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
export default SvgSport;